import * as React from 'react';


import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import banner from '@assets/images/skinplace/banner.png';

import { Button } from '@components/button';

import * as Styled from './skinplace-banner.styled.ts';

const SkinplaceBanner = () => {
	const { t } = useTranslation('skinplace');

	return (
		<Styled.Wrapper>
			<Styled.Left>
				<img src={banner} alt='' />
			</Styled.Left>
			<Styled.Right>
				<Styled.Title dangerouslySetInnerHTML={{ __html: t('main_title') }} />
				<Styled.Description>{t('main_description')}</Styled.Description>
				<Styled.ButtonWrapper>
					<Link to='/skinplace'>
						<Button color='primary' size={'large'}>
							{t('exchange_title')}
						</Button>
					</Link>
				</Styled.ButtonWrapper>
			</Styled.Right>
		</Styled.Wrapper>
	);
};

export default SkinplaceBanner;
